'use client';

import { useEffect } from 'react';

export default function ScrollAnimation() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target as HTMLElement;

            if (el.hasAttribute('data-scroll-animate-children')) {
              Array.from(el.children).forEach((child, index) => {
                setTimeout(() => {
                  (child as HTMLElement).style.cssText += 'opacity:1;transform:translateY(0)';
                }, index * 100);
              });
              el.classList.add('in-view');
            } else {
              el.classList.add('in-view');
            }

            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px',
      }
    );

    const animatedElements = document.querySelectorAll('[data-scroll-animate], [data-scroll-animate-children]');
    animatedElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return null;
}
